var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.004 3.47657C19.8802 3.39402 19.7564 3.39402 19.6326 3.43529C18.6008 3.88934 17.5277 3.55912 16.9088 2.73361C16.6199 2.36214 16.4548 1.86683 16.4548 1.41277C16.4548 1.28895 16.4135 1.20639 16.331 1.12383C16.2484 1.04126 16.1659 1 16.042 1H11.8322C11.5846 1 11.4195 1.1651 11.4195 1.41276V16.0659V16.1484C11.3369 16.8914 10.7591 17.428 10.0163 17.428C9.23208 17.428 8.57173 16.7676 8.57173 15.9833C8.57173 15.2403 9.10825 14.6625 9.85117 14.5799C10.0575 14.5386 10.2226 14.3735 10.2226 14.1672V9.37913C10.2226 9.13147 10.0575 8.96637 9.80988 8.96637H9.72734C5.93035 9.13147 3 12.186 3 15.9832C3 19.8633 6.13664 23 10.016 23C13.6479 23 16.7019 20.1932 16.9909 16.6021C17.0322 16.5609 17.0322 16.4783 17.0322 16.437V8.47079C17.9401 8.67717 18.8894 8.75973 19.8798 8.59462C20.0862 8.55334 20.21 8.38824 20.21 8.18186V3.80671C20.21 3.68289 20.1278 3.55912 20.004 3.47657Z",
    fill: "#B1BFB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d1c60397b1a5823b4caa2948c76a0bd4.svg";
export { ForwardRef as ReactComponent };